<template>
	<div class="connection-status-container">
		<ClipLoader color="#5F8FF1" size="18px" v-if="isLoadingProfile" />
		<div v-else-if="needsToConnect">
			<div @click="$emit('close-profile-selection')" class="close-button" v-if="isSelectingProfile">close</div>
			<AppTooltip :disabled="!editMode" v-else top text="This button can only be clicked in test mode">
				<AnemicButton :disabled="editMode" :class="{ striped: editMode }" @click="$emit('open-profile-selection')" class="connect-button">
					Connect
				</AnemicButton>
			</AppTooltip>
		</div>
		<div v-else class="display-flex flex-column flex-align-end" :class="{ 'flex-align-start': alignStart }">
			<div v-if="isConnected" class="connection-state display-flex flex-row flex-align-center">
				<SIcon class="connection-status-icon mr-1" name="successfull-connection" />
				Connected
			</div>
			<div v-else-if="isConnectionFailed" class="connection-state display-flex flex-row flex-align-center">
				<SIcon class="connection-status-icon mr-1" name="failed-connection" />
				Test failed.
				<div @click="$emit('reconnect-profile')" class="ml-1 reconnect-button">Reconnect</div>
			</div>
			<div v-if="isSelectingProfile" @click="$emit('close-profile-selection')" class="close-button">close</div>
			<InputWithHoveringEditButton
				v-else
				class="connection-description"
				:value="selectedProfileDisplayName"
				@edit="$emit('open-profile-selection')"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import AppTooltip from '@/components/common/AppTooltip';
import { getCredentialsForService } from '@/store/modules/apps/getters';
import InputWithHoveringEditButton from '@/components/common/InputWithHoveringEditButton.vue';
export default {
	name: 'ProfileConnectionStatus',
	props: {
		editMode: { type: Boolean },
		serviceId: { type: Number },
		profileId: { type: Number },
		alignStart: { type: Boolean },
		isLoadingProfile: { type: Boolean },
		isSelectingProfile: { type: Boolean },
		isConnectionFailed: { type: Boolean },
	},
	components: { AppTooltip, ClipLoader, InputWithHoveringEditButton },
	computed: {
		...mapGetters([getCredentialsForService.fullPath]),
		profileItemsList() {
			return this[getCredentialsForService.fullPath](this.serviceId) || [];
		},
		selectedProfile() {
			return this.profileItemsList.find((profItem) => profItem.id === this.profileId) || {};
		},
		selectedProfileDisplayName() {
			return this.selectedProfile.connection_name;
		},
		needsToConnect() {
			return !this.profileId;
		},
		isConnected() {
			return !!this.profileId;
		},
	},
	data() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
.connection-state {
	font-size: 14px;
	color: var(--primary-font-color);
}
.connection-description {
	max-width: 200px;
}

.connection-status-container {
	.close-button {
		cursor: pointer;
		font-size: 11px;
		font-weight: 500;
		text-decoration: underline;
		color: var(--primary-font-color);
	}
}

.connect-button {
	font-size: 14px !important;
	color: var(--bg-color) !important;

	width: 97px !important;
	padding: 0px !important;
	height: 35px !important;
	border-radius: 8px !important;
	background: var(--bold-border-color) !important;
	border: 1px solid var(--bold-border-color) !important;

	&:disabled {
		color: var(--bg-color) !important;
	}
}

.connection-status-icon {
	margin-top: 3px;
}

.reconnect-button {
	cursor: pointer;
	font-size: 14px;
	text-decoration: underline;
	color: var(--bold-border-color);
}

.striped {
	background: repeating-linear-gradient(45deg, var(--bold-border-color), var(--bold-border-color) 3px, grey 3px, grey 6px) !important;
}
</style>
